import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthServiceUser } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class PageAuthGuard implements CanActivate {
  constructor(private authService: AuthServiceUser, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const action = route.data['action']; // e.g., 'view', 'edit', 'delete'
    const module = route.data['module'];

    if (this.authService.hasPermission(action, module) && this.authService.isUserAuthenticated()) {
      return true;
    } else if (!(this.authService.isUserAuthenticated())) {
      this.authService.isErrorPageShown = false;
      this.authService.logout();
      this.router.navigate(['/login']);
      return false;
    } else if (this.authService.isErrorPageShown) {
      this.authService.isErrorPageShown = false;
      this.authService.logout();
      this.router.navigate(['/login']);
      return false;
    } else {
      this.router.navigate(['/404']);
      return false;
    }
  }
}
